import { Capacitor } from "@capacitor/core";

const normalizeWhatsappPhone = (phone) => {
  const digits = (phone || "").replace(/\D/g, "");
  return digits.length === 10 ? `52${digits}` : digits;
};

export const buildWhatsappUrl = (phone, message) => {
  const clean = normalizeWhatsappPhone(phone);
  return `https://wa.me/${clean}?text=${encodeURIComponent(message)}`;
};

export const buildWhatsappBusinessUrl = (phone, message) => {
  const clean = normalizeWhatsappPhone(phone);
  const text = encodeURIComponent(message || "");
  const fallback = encodeURIComponent(`https://wa.me/${clean}?text=${text}`);

  return `intent://send?phone=${clean}&text=${text}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;S.browser_fallback_url=${fallback};end`;
};

export const openWhatsappBusiness = (phone, message) => {
  const fallbackUrl = buildWhatsappUrl(phone, message);

  try {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === "android") {
      window.location.href = buildWhatsappBusinessUrl(phone, message);

      window.setTimeout(() => {
        if (document.visibilityState === "visible") {
          window.location.href = fallbackUrl;
        }
      }, 1200);
      return;
    }
  } catch {
    // Ignore native detection errors and use the normal web fallback.
  }

  window.open(fallbackUrl, "_blank", "noopener,noreferrer");
};

export const orderWhatsappMessage = (order, autoIntro = "Hola Kelifa, hice un pedido en la app.") => {
  const cartItems = order.customization?.cart_items || [];
  const productLines = cartItems.length
    ? cartItems.map((item) => `- ${item.product_name} x ${item.quantity}`).join("\n")
    : order.product_name;
  return (
    `${autoIntro}\n\n` +
    `Folio: ${order.folio}\n` +
    `Nombre: ${order.customer_name}\n` +
    `Producto(s):\n${productLines}\n` +
    `Fecha: ${order.delivery_date}\n` +
    `Hora: ${order.delivery_time || "-"}\n` +
    `Total estimado: $${Number(order.estimated_price || 0)} MXN\n\n` +
      `Quedo pendiente de confirmación. Gracias.`
  );
};

export const adminOrderWhatsappMessage = (order) => {
  const firstName = (order.customer_name || "").trim().split(/\s+/)[0] || "hola";
  const cartItems = order.customization?.cart_items || [];
  const productLines = cartItems.length
    ? cartItems.map((item) => `- ${item.product_name} x ${item.quantity}`).join("\n")
    : `- ${order.product_name} x ${order.quantity || 1}`;
  const total = Number(order.final_price || order.estimated_price || 0);

  return (
    `Hola ${firstName} 😊 Soy Kelifa Repostería.\n\n` +
    `Te contacto para confirmar tu pedido:\n` +
    `Folio: ${order.folio}\n` +
    `Producto(s):\n${productLines}\n` +
    `Fecha: ${order.delivery_date}\n` +
    `Hora: ${order.delivery_time || "-"}\n` +
    `Total estimado: $${total} MXN\n\n` +
    `¿Me confirmas por favor que los datos están correctos para continuar con la confirmación del pedido?`
  );
};

export const adminQuoteWhatsappMessage = (quote) => {
  const firstName = (quote.customer_name || "").trim().split(/\s+/)[0] || "hola";
  return (
    `Hola ${firstName} 😊 Soy Kelifa Repostería.\n\n` +
    `Te contacto sobre tu solicitud de cotización ${quote.folio}.\n` +
    `Evento: ${quote.event_type || "-"}\n` +
    `Fecha: ${quote.event_date || "-"}\n` +
    `Servicios: ${(quote.services || []).join(", ") || "-"}\n\n` +
    `¿Me ayudas confirmando estos datos para darte seguimiento?`
  );
};
